import axios from "axios";

const API_BASE = String(process.env.REACT_APP_NOT_SECRET_CODE || "").replace(
  /\/$/,
  "",
);
const API_V1_BASE = /\/api\/v1$/i.test(API_BASE)
  ? API_BASE
  : `${API_BASE}/api/v1`;
const OUTREACH_BASE = `${API_V1_BASE}/cashless-opd-outreach`;

const defaultHeaders = (token) => ({
  "Content-Type": "application/json",
  "X-Request-ID": "124",
  "X-Country-Code": "LK",
  "X-Client-Name": "WEBSITE",
  "X-Client-Version": "123",
  Authorization: `Bearer ${token}`,
});

const compactParams = (params) =>
  Object.keys(params || {}).reduce((result, key) => {
    const value = params[key];
    if (value !== undefined && value !== null && value !== "") {
      result[key] = value;
    }
    return result;
  }, {});

/**
 * Fetch the paginated outreach dashboard.
 * @param {string} token
 * @param {{date: string, timezone: string, status?: string, search?: string,
 * opted_out?: boolean, page: number, records_per_page: number}} filters
 * @param {*} cancelToken Axios cancellation token.
 */
export const fetchCashlessOpdOutreachDashboard = (
  token,
  filters,
  cancelToken,
) =>
  axios.get(`${OUTREACH_BASE}/dashboard`, {
    cancelToken,
    headers: defaultHeaders(token),
    params: compactParams(filters),
  });

export const blockCashlessOpdContact = (token, leadId, reason) =>
  axios.post(
    `${OUTREACH_BASE}/contacts/${encodeURIComponent(leadId)}/block`,
    { reason, source: "dashboard" },
    { headers: defaultHeaders(token) },
  );

export const unblockCashlessOpdContact = (token, leadId, reason) =>
  axios.post(
    `${OUTREACH_BASE}/contacts/${encodeURIComponent(leadId)}/unblock`,
    { reason },
    { headers: defaultHeaders(token) },
  );

export const fetchCashlessOpdContactEligibility = (token, leadId) =>
  axios.get(
    `${OUTREACH_BASE}/contacts/${encodeURIComponent(leadId)}/eligibility`,
    { headers: defaultHeaders(token) },
  );

export const createOutreachCancelSource = () => axios.CancelToken.source();

export const isOutreachRequestCancelled = (error) => axios.isCancel(error);
